<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isLinked" placeholder="请选择合约上链状态" size="small">
                        <el-option label="不限制合约上链状态" value=""></el-option>
                        <el-option label="仅看已上链的 " :value="1"></el-option>
                        <el-option label="仅看未上链的" :value="0"></el-option>
                        <el-option label="仅看上链失败的" :value="2"></el-option>
                        <el-option label="仅看上链中的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isSupportTransfer" placeholder="请选择是否支持转赠" size="small">
                        <el-option label="不限制是否支持转赠" value=""></el-option>
                        <el-option label="仅看支持转赠的 " :value="1"></el-option>
                        <el-option label="仅看不支持转赠的" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isBindGoods" placeholder="请选择是否有关联项" size="small">
                        <el-option label="不限制是否有关联项" value=""></el-option>
                        <el-option label="仅看有关联项的 " :value="1"></el-option>
                        <el-option label="仅看无关联项的" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.goodsName" placeholder="请输入关联项名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="合约编号" :value="1"></el-option>
                            <el-option label="合约名称" :value="2"></el-option>
                            <el-option label="合约流水号" :value="3"></el-option>
                            <el-option label="作者" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="创建时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/contract/save')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="$router.push('/nftManage/contract/add')">
                创建合约</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="isLinked" label="合约上链状态" min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isLinked == 0">未上链</span>
                        <span v-else-if="scope.row.isLinked == 1" class="color-success">已上链</span>
                        <span v-else-if="scope.row.isLinked == 2" class="color-danger">上链失败</span>
                        <span v-else-if="scope.row.isLinked == 3" class="color-warning">上链中</span>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="合约编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cover" label="合约图片">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.cover | coverImage(120,120)" fit="cover"
                            :preview-src-list="[scope.row.cover]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="合约名称" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="chainClassId" label="联盟链合约地址" show-overflow-tooltip min-width="120"></el-table-column> -->
                <!-- <el-table-column prop="price" label="合约价格"></el-table-column> -->
                <el-table-column prop="serialNo" label="合约流水号" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="nftNum" label="铸造NFT数量" min-width="100"></el-table-column>
                <el-table-column prop="author" label="作者" show-overflow-tooltip></el-table-column>
                <el-table-column prop="isSupportTransfer" label="是否支持转赠" min-width="100">
                    <template slot-scope="scope">{{scope.row.isSupportTransfer ? '是' : '否'}}</template>
                </el-table-column>
                <el-table-column prop="rightsNum" label="权益数"></el-table-column>
                <el-table-column prop="goodsName" label="关联项" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.goodsId" :href="`/goodsManage/goods/edit/${scope.row.goodsId}`"
                            type="primary" class="ellipsis">
                            {{scope.row.goodsName}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="isBindGoods" label="是否有关联项" min-width="100">
                    <template slot-scope="scope">{{scope.row.isBindGoods ? '是' : '否'}}</template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="150">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="240">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/contract/upChain') && (scope.row.isLinked == 0 || scope.row.isLinked == 2)"
                            type="text" size="small" @click="upChain(scope.row)">{{scope.row.isLinked == 0 ? '合约' :
                            '重新'}}上链</el-button>
                        <el-button v-if="$utils.have('/contract/save')" type="text" size="small"
                            @click="edit(scope.row.id)">编辑</el-button>
                        <el-button v-if="$utils.have('/nft/pageList')" type="text" size="small"
                            @click="nftList(scope.row)">NFT列表</el-button>
                        <el-button v-if="scope.row.serialNo" type="text" size="small"
                            @click="copyLink(scope.row.serialNo)">NFT拥有者页面地址</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <input class="copyTool" ref="copyTool" :value="copyUrl" />
    </div>
</template>
<script>
const defaultParams = {
    pageNo: 1,
    goodsName: "", //关联项名称	
    isBindGoods: "",//是否有关联项 0:没有 1:有
    isLinked: "",//是否上链 1：是 0：否
    startTime: "",
    endTime: "",
    isSupportTransfer: "",//是否支持转赠 1：支持 0：不支持
    searchType: 1, //查询类型 1:合约编号 2:合约名称 3:合约地址 4:作者
    searchValue: "", //查询值	
    timeType: 1
}
export default {
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                goodsName: this.$route.query.goodsName || '',
                isBindGoods: parseInt(this.$route.query.isBindGoods) || "",
                isLinked: parseInt(this.$route.query.isLinked) || "",
                startTime: this.$route.query.startTime || '',
                endTime: this.$route.query.endTime || '',
                isSupportTransfer: parseInt(this.$route.query.isSupportTransfer) || "",
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                timeType: parseInt(this.$route.query.timeType || 1),
            },
            listLoading: true,
            datetimerange: [this.$route.query.startTime || '', this.$route.query.endTime || ''],

            sswap:process.env.VUE_APP_SSWAP_URL,
			copyUrl: "",
			copyTimer: null
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || ''
            }
            this.listLoading = true;
            this.$request({
                url: "/contract/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },

        //跳转编辑
        edit(id) {
            this.$router.push({
                path: `/nftManage/contract/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                },
            });
        },
        //跳转NFT
        nftList(data) {
            this.$router.push({
                path: `/nftManage/nft/list`,
                query: {
                    searchType2: 1,
                    searchValue2: data.name
                },
            });
        },
        //上链
        upChain(item) {
            const confirmMsg = `<div style="text-align:left;"><div>1、合约上链后，合约主要信息如名称、权益将无法修改</div><div>2、合约上链需5-10分钟生效，请耐心等待</div></div>`
            this.$confirm(confirmMsg, '确认要将改合约上链吗？', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
            }).then(() => {
                this.$request({
                    url: "/contract/upChain",
                    method: "POST",
                    params: {
                        id: item.id,
                    },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
            });
        },

        //复制链接
        copyLink(code){
            clearTimeout(this.copyTimer);
            this.copyUrl = `${this.sswap}/pages/special/nft/owner?code=${code}`;
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
    }
}
</script>
<style lang="scss" scoped>
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
</style>